import React from "react";
import { makeStyles } from "@fluentui/react-components";
import RenderIf from "../common/RenderIf/RenderIf";
import LoadingSpinner from "../common/LoadingSpinner/LoadingSpinner";
import EmailForm from "../forms/EmailForm/EmailForm";
import CompanyForm from "../forms/CompanyForm/CompanyForm";
import PasswordForm from "../forms/PasswordForm/PasswordForm";
import useLogIn from "./useLogIn";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "12px",
    width: "100%",
    height: "100%",
    overflowX: "hidden",
    overflowY: "auto",
  },
});

export const LogIn: React.FC = () => {
  const {
    step,
    error,
    setError,
    isLoading,
    companyOptions,
    handleEmailSubmit,
    handleCompanySelect,
    handlePasswordSubmit,
  } = useLogIn();

  const styles = useStyles();

  return (
    <div className={styles.container}>
      <RenderIf shouldRender={isLoading}>
        <LoadingSpinner />
      </RenderIf>
      {step === "email" && (
        <EmailForm
          error={error}
          saving={isLoading}
          onClearError={() => setError(undefined)}
          onSubmit={handleEmailSubmit}
        />
      )}
      {step === "company" && companyOptions && (
        <CompanyForm
          error={error}
          saving={isLoading}
          companies={companyOptions}
          onClearError={() => setError(undefined)}
          onSubmit={handleCompanySelect}
        />
      )}
      {step === "password" && (
        <PasswordForm
          error={error}
          saving={isLoading}
          onClearError={() => setError(undefined)}
          onSubmit={handlePasswordSubmit}
        />
      )}
    </div>
  );
};

export default LogIn;
